import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSubLoading } from '../../Redux/Services/AuthSlice';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, FindTranslatedKey, handleDateChange } from '../CommonComponents/CustomHooks';
import { handleDownloadExcel } from '../CommonComponents/ExportData';
import { DateBox, FormButton, InputBox, base64ToBlob } from '../CommonComponents/InputBox';
import { Table } from '../CommonComponents/Table';

const DispatchReport = () => {
    const inputrefs = useRef([]);
    const dispatch = useDispatch([]);
    const [isLoading, setIsLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const selectedDate = new Date();
    selectedDate.setDate(selectedDate.getDate() - 14);
    const selectedDate2 = new Date();
    selectedDate2.setDate(selectedDate2.getDate());
    const dateArr = selectedDate.toDateString().split(" ");
    const formattedDate = `${dateArr[2]}-${dateArr[1]}-${dateArr[3]}`;
    const dateArr2 = selectedDate2.toDateString().split(" ");
    const formattedDate1 = `${dateArr2[2]}-${dateArr2[1]}-${dateArr2[3]}`;
    const [formData, setFormData] = useState({
        DispatchDateFrom: formattedDate,
        DispatchDateTo: formattedDate1,
        DispatchNo: '',
        ManifestNo: '',
    });
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };
    const getDispatchReportData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...formData,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setIsLoading(true)
        let data = await ApiCall('/api/Report/DispatchReport', GetData)
        setTableData(data)
        setIsLoading(false)
        if (data.Status === 'ERROR' || data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
    }

    const handlePrint = async (value) => {
        await dispatch(setSubLoading(true))
        let imgresult = await ApiCall('/api/Report/DispatchPrint', { DispatchNo: value });
        await dispatch(setSubLoading(false))
        let result = imgresult;
        if (result.status === 'ERROR' || result.status === 'EXPIRED'){
            await NotificationSound(result.status, result.message, result.focus, inputrefs, handleClear);
            await dispatch(setSubLoading(false))
        }
        const blob = base64ToBlob(result.documentPdfBase64?.split(',')[1], 'application/pdf');
        const url = URL.createObjectURL(blob);
        const PDFWindow = window.open("");
        PDFWindow.document.write("<iframe width='100%' height='100%' src='" + url + "'></iframe>");
    }
    const handleClear = () => {
        setFormData({
            DispatchDateFrom: formattedDate,
            DispatchDateTo: formattedDate1,
            DispatchNo: '',
            ManifestNo: '',
        });
        getDispatchReportData()
        inputrefs.current['txtDispatchDateFrom'].focus()
    }

    const handleChange1 = (event, value) => {
        getDispatchReportData(value);
    };
    useEffect(() => {
        getDispatchReportData()
    }, [sortConfig])
    useEffect(() => {
      
        document.title = 'Dispatch /UnDispatch Report'
        inputrefs.current['txtDispatchDateFrom'].focus()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <h6 className="m-0">  {FindTranslatedKey('Dispatch /UnDispatch Report')} </h6>
                    </div>
                    <div className='card-body pb-1'>
                        <div className='row'>
                            <DateBox
                                inputrefs={inputrefs}
                                label="Date From"
                                placeholder="Date From"
                                id='txtDispatchDateFrom'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtDispatchDateTo'].focus()
                                    };
                                }}
                                required={false}
                                selected={formData.DispatchDateFrom === '' ? '' : new Date(formData.DispatchDateFrom)}
                                onChange={(e) => handleDateChange(e, setFormData, formData, 'DispatchDateFrom')}
                            />
                            <DateBox
                                inputrefs={inputrefs}
                                label="Date To"
                                placeholder="Date To"
                                id='txtDispatchDateTo'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtDispatchNo'].focus()
                                    };
                                }}
                                required={false}
                                selected={formData.DispatchDateTo === '' ? '' : new Date(formData.DispatchDateTo)}
                                onChange={(e) => handleDateChange(e, setFormData, formData, 'DispatchDateTo')}
                            />

                            <InputBox
                                id="txtDispatchNo"
                                PlaceHolderText="Awb No."
                                autoComplete="off"
                                maxLength='25'
                                required={false}
                                label='Awb No.'
                                value={formData.DispatchNo}
                              //  onChange={(e) => setFormData({ ...formData, DispatchNo: convertToNumber(e.target.value) })}
                                onChange={(e) => {
                                    //let { value } = e.target
                                    //const aphanum = value.replace(/[^a-zA-Z0-9]/g, '')
                                    setFormData({ ...formData, DispatchNo: e.target.value })
                                }}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtManifestNo'].focus()
                                    }
                                }}
                            />
                            <InputBox
                                id="txtManifestNo"
                                PlaceHolderText="Manifest No"
                                autoComplete="off"
                                maxLength='30'
                                required={false}
                                label='Manifest No.'
                                value={formData.ManifestNo}
                                onChange={(e) => setFormData({ ...formData, ManifestNo: e.target.value})}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['btnSub'].focus()
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <div className='card-body'>
                        <FormButton
                            id={'btnSub'}
                            Search={true}
                            save={false}
                            inputrefs={inputrefs}
                            handleSubmit={getDispatchReportData}
                            handleExport={async () => {
                                await dispatch(setSubLoading(true))
                                handleDownloadExcel(`/api/Report/DispatchReport`, formData, 'Dispatch Report')
                                await dispatch(setSubLoading(false))
                            }}
                            handleClear={handleClear}
                        />
                    </div>
                </div>
            </div>
            <Table
                PageName={'DispatchReport'}
                loading={isLoading}
                Filter={false}
                tableData={tableData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handlePrint={handlePrint}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />
        </>
    )
}
export default DispatchReport;